import React, { useContext } from 'react'
import Box from '@material-ui/core/Box'
import isEmpty from 'lodash/isEmpty'

import { LiabilitiesContext } from '../../context'
import { ActionablesContext } from '@contexts/ActionablesContext'
import { Grid } from '@components/layout/Grid'
import { Button } from '@components/Button'
import { CardActionButton } from '@components/layout/Card/CardActionButton'
import { Card, CardFooter } from '@components/layout/Card'
import { LiabilityCard } from '@components/Liabilities/Card'

export const CurrentLiabiliiesCards = () => {
  const { state } = useContext(LiabilitiesContext)
  const { liabilities, scenario } = state

  return (
    <Grid mediumColumns>
      <AddLiabilityCard />
      {liabilities.map((liability, index) =>
        <LiabilityCard
          key={index}
          liability={liability}
          Footer={() =>
            scenario?.id
              ? <LiabilityCardFooter
                index={index}
              />
              : null
          }
        />
      )}
    </Grid>
  )
}

const AddLiabilityCard = () => {
  const { readOnly, frozen } = useContext(ActionablesContext)

  if (frozen) return null

  return (
    <Card darkBorder className='ui-card--centered-cue-card text-center'>
      {readOnly
        ? <GoToScenarioPlanning />
        : <AddLiabilitiesButtons />}
    </Card>
  )
}

const AddLiabilitiesButtons = () => {
  const {
    state: { scenario },
    actions: { goToAddLiability }
  } = useContext(LiabilitiesContext)

  const scenarioId = scenario?.id

  return (
    <Box m='1rem'>
      <Button disabled={!scenarioId} fullWidth primary onClick={goToAddLiability} trackAs='Add Liaility card: Add Liability'>Add liability</Button>
      {!scenarioId &&
        <small>Select an individual to add a liability</small>
      }
    </Box>
  )
}

const GoToScenarioPlanning = () => {
  const { state: { onCreateNewScenario, liabilities } } = useContext(LiabilitiesContext)
  const addLiabilityText = isEmpty(liabilities) ? 'Want to add a liability?' : 'Want to add another liability?'

  return (
    <Box
      display='flex'
      flexDirection='column'
      justifyContent='center'
      alignItems='center'
      mx='2rem'
    >
      <h5>{addLiabilityText}</h5>
      <Button
        primary
        trackAs='Add liability card: New scenario'
        onClick={() => onCreateNewScenario()}
      >
        Create a new scenario
      </Button>
    </Box>
  )
}

const LiabilityCardFooter = ({ index }) => {
  const { actions } = useContext(LiabilitiesContext)
  const { readOnly } = useContext(ActionablesContext)
  const { updateLiability, deleteLiability } = actions
  return (
    !readOnly &&
    <CardFooter>
      <CardActionButton icon="trash" label="Delete liability" trackAs='Liability Card: Delete' className='liability-action' onClick={deleteLiability(index)} />
      <CardActionButton icon="pencil" label="Update liability" trackAs='Liability Card: Update' className='liability-action' onClick={updateLiability(index)} />
    </CardFooter>
  )
}
